module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-ExtraBoldItalic.81e142cb.otf";